import { render, staticRenderFns } from "./CreateEditPerguntaModal.vue?vue&type=template&id=767f3918&"
import script from "./CreateEditPerguntaModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditPerguntaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports